<template>
  <div>
    {{ ticket.subject }}
    <br>
    <small>
      <span class="xs-mr-10">
        <i class="fas fa-building" /> {{ mainWebsite?.organisation?.name }}
      </span>
      <i class="fas fa-link" /> {{ mainWebsite?.simple_url }}
    </small>
  </div>
</template>

<script>
export default {
  props: {
    ticket: {
      type: Object,
      required: true,
    }
  },
  computed: {
    mainWebsite() {
      return this.ticket.websites[0] ?? {};
    }
  }
}
</script>

